'use strict';

var _ = require('lodash');
var CompetitorDataFilterService = function CompetitorDataFilterService() {
  function getLatestShoppingRecordIds(flattenedCompetitorData) {
    var latestEventTimeStamp = _.chain(flattenedCompetitorData).sortBy('eventTimeStamp').map('eventTimeStamp').last().value();
    var competitorDataWithLatestTimeStamp = _.groupBy(flattenedCompetitorData, 'eventTimeStamp')[latestEventTimeStamp];
    return _.map(competitorDataWithLatestTimeStamp, 'shoppingRecordId');
  }
  function filterLatestShoppingData(flattenedCompetitorData) {
    var latestShoppingRecordIds = getLatestShoppingRecordIds(flattenedCompetitorData);
    return _.filter(flattenedCompetitorData, function (compData) {
      return compData.source === 'COMPETITORFARE' || latestShoppingRecordIds.indexOf(compData.shoppingRecordId) !== -1;
    });
  }
  function filterCompFares(competitorCompFares, originalService, sources) {
    return _.chain(competitorCompFares).filter(function (compFare) {
      return isCompOrHostMatchingSelectedServices(compFare, originalService);
    }).filter(function (compFare) {
      return isMatchingSources(compFare, sources);
    }).value();
  }
  function isCompOrHostMatchingSelectedServices(compFare, originalService) {
    var originalFlightNbrs = originalService.serviceId.split('.')[2].split('[')[0].replace(/\|/g, ',');
    var referenceFlightNbrs = transformReferenceServiceIds(originalService.referenceServiceIds);
    return compFare.marketingCarrier !== originalService.carrier || isMatchingHostRowsBySelectedServices(compFare, originalFlightNbrs, referenceFlightNbrs, originalService.direction);
  }
  function isMatchingSources(compFare, sources) {
    return sources.indexOf(compFare.source) !== -1;
  }
  function transformReferenceServiceIds(referenceServiceIds) {
    if (referenceServiceIds) {
      return _.transform(referenceServiceIds, function (result, serviceId) {
        result.push(serviceId.split('.')[2].split('[')[0].replace(/\|/g, ','));
      }, []);
    }
    return [];
  }
  function areFlightsMatchingSelectedServices(originalDirectionFlightNbrs, reversDirectionFlightNbrs, originalFlightNbrs, referenceFlightNbrs) {
    if (referenceFlightNbrs && !_.isEmpty(referenceFlightNbrs)) {
      return originalDirectionFlightNbrs === originalFlightNbrs && referenceFlightNbrs.indexOf(reversDirectionFlightNbrs) !== -1;
    } else {
      return originalDirectionFlightNbrs === originalFlightNbrs;
    }
  }
  function isMatchingHostRowsBySelectedServices(compFare, originalFlightNbrs, referenceFlightNbrs, originalDirection) {
    return originalDirection === 'OUTBOUND' ? areFlightsMatchingSelectedServices(compFare.outboundFlightNumberList, compFare.inboundFlightNumberList, originalFlightNbrs, referenceFlightNbrs) : areFlightsMatchingSelectedServices(compFare.inboundFlightNumberList, compFare.outboundFlightNumberList, originalFlightNbrs, referenceFlightNbrs);
  }
  return {
    filterCompFares: filterCompFares,
    getLatestShoppingRecordIds: getLatestShoppingRecordIds,
    filterLatestShoppingData: filterLatestShoppingData
  };
};
CompetitorDataFilterService.$inject = [];
module.exports = CompetitorDataFilterService;